var exports = {
  "DD": "x234b8571--c782a7--title",
  "p_": "x234b8571--c782a7--list",
  "AS": "x234b8571--c782a7--item",
};

module.exports = exports;
